import { ScriptLoader } from '../../utils/loadScript.js';
import { eventBus } from '../../eventbus/eventbus.js';

export const bvLoad = {
  name: 'bv-load',
  inserted: function (_el, { value }) {
    let async = true;
    const scriptLoader = new ScriptLoader();
    const scriptAlreadyLoaded = document.querySelector(
      `script[src="${value}"]`
    );
    function waitForResource(resource) {
      let counter = 0;
      const maxChecks = 50;
      return new Promise((resolve, reject) => {
        const checkInterval = setInterval(() => {
          if (window[resource]) {
            clearInterval(checkInterval);
            resolve();
          } else if (counter >= maxChecks) {
            clearInterval(checkInterval);
            reject(new Error('Maximum number of checks reached'));
          }
          counter++;
        }, 100);
      });
    }

    function initBvListeners() {
      // eslint-disable-next-line no-undef
      BV.configure('global', {
        events: {
          bvRender: function (data) {
            eventBus.$emit('bvRender', data);
          },
          submissionLoad: function (data) {
            eventBus.$emit('submissionLoad', data);
          },
          submissionClose: function (data) {
            eventBus.$emit('submissionClose', data);
          },
          submissionSubmitted: function (data) {
            eventBus.$emit('submissionSubmitted', data);
          },
        },
      });
    }

    if (scriptAlreadyLoaded) {
      waitForResource('BV').then(() => {
        initBvListeners();
      });
    } else {
      scriptLoader
        .loadScript('bv-loader', value, 'main', async)
        .then(() => {
          initBvListeners();
        })
        .catch((error) => {
          console.error(error);
        });
    }
  },
};
